import React from 'react';
import { IIcon } from '../interfaces';

function DropDownShow({ onClick, type, color, className, styles }: IIcon.Props) {

    return (
        <i className={`fa${type ? type?.substr(0,1) : "s"} fa-carte-right ${className ?? ""} text-${color}`} onClick={onClick} style={styles}> </i>
    )
}

export default DropDownShow;